import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


/**
 * Quick Button
 */
const QuickBtn = ({ tempItem, idx, boxStyle, onClickEvt }) => {

  return (
    <div className="_quick_buttons_area">
      <button type="button" className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value, tempItem.button.action, tempItem.button.label)}>
        {ReactHtmlParser(`${tempItem.button?.label}`)}
      </button>
    </div>
  );
};
const Button = ({ quickId, boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  const [mouseDown, setMouseDown] = useState(false);
  const [startX, setStartX] = useState();
  const slider = useRef(null);

  // const slider = document.querySelector('#_quick_buttons_scroll_'+ quickId);

  // setMouseDown(false);
  // let startX
  // let scrollLeft;


  const startDragging = (e) => {
    e.preventDefault();

    setMouseDown(true);
    setStartX(e.pageX + slider.current.scrollLeft);
    // setScrollLeft(slider.current.scrollLeft);
  }

  const stopDragging = (e) => {
    setMouseDown(false);
  }

  const onDrageMove = (e) => {
    if(mouseDown) { 
      const {scrollWidth, clientWidth, scrollLeft} = slider.current;
      slider.current.scrollLeft = startX - e.pageX;

      if(scrollLeft === 0) {
        setStartX(e.pageX);
      }else if(scrollWidth <= clientWidth + scrollLeft) {
        setStartX(e.pageX + scrollLeft);
      }
    }
  }

  return (
    <>
        <div className="_quick_buttons_div" ref={slider} onMouseDown={startDragging} onMouseMove={onDrageMove} onMouseUp={stopDragging} onMouseLeave={stopDragging} >
          {items && (items.map((tempItem, idx) => {
            return <QuickBtn key={`${tempItem.button?.label}_${idx}`} tempItem={tempItem} idx={idx} boxStyle={boxStyle} onClickEvt={onClickEvt} />;
          }))}
        </div>
    </>
  );
};
Button.propTypes = {
  quickId: PropTypes.string,
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Button.defaultProps = {
  quickId: '',
  boxStyle: { width: 150, margin: 10, height: '220px' },
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};
QuickBtn.propTypes = {
  boxStyle: PropTypes.object,
  idx: PropTypes.number,
  tempItem: PropTypes.object,
  onClickEvt: PropTypes.func,
};
QuickBtn.defaultProps = {
  boxStyle: {},
  idx: 0,
  tempItem: {},
  onClickEvt: null,
};


export default Button;
